import React from 'react';
import Notifhp from "./Notifhp";
import H2Homepage from "./H2homepage";
import iconnotif from '../../style/icons/notification.svg'

const NotifhpContainer = () => {
    return (
        <div className={'notif-container'}>
            <H2Homepage title={'התראות'} iconName={iconnotif}/>
            <div className={'notif-main-container'}>
                <Notifhp/>
                <Notifhp/>
            </div>

        </div>
    );
};

export default NotifhpContainer;